module.exports = __webpack_public_path__ + "media/images/emblems/L-Abergement-blazono-6fab4a02d3cecb156cb98f3f79401cb2.png";